import { Subscription } from 'rxjs';
import { createEffect } from './effect';
import { createStore } from './store';
/**
 * Creates `Scope` instance.
 */
export function createScope() {
    const subscriptions = new Subscription();
    function registerTeardown(teardown) {
        subscriptions.add(teardown);
    }
    function destroy() {
        subscriptions.unsubscribe();
    }
    function createController(factory) {
        const controller = factory();
        registerTeardown(controller.destroy);
        return controller;
    }
    return {
        add: registerTeardown,
        destroy,
        createController,
        createStore(initialState, options) {
            return createController(() => createStore(initialState, options));
        },
        createEffect(handler, options) {
            return createController(() => createEffect(handler, options));
        },
        handle(source, handler, options) {
            const effect = createController(() => createEffect(handler, options));
            effect.handle(source);
            return effect;
        },
        subscribe(source, nextOrObserver) {
            const subscription = source.subscribe(nextOrObserver);
            registerTeardown(subscription);
            return subscription;
        },
    };
}
//# sourceMappingURL=scope.js.map